import { Builder } from '@builder.io/react';
import TicketCards from './TicketCards';

Builder.registerComponent(TicketCards, {
  name: 'TicketCards',
  inputs: [
    {
      name: 'tickets',
      type: 'list',
      defaultValue: [{
        icon: '',
        title: 'Ticket title here',
        text: 'Benefit description here',
      }],
      copyOnAdd: true,
      subFields: [
        {
          name: 'title',
          type: 'richText',
        },
        {
          name: 'currency',
          type: 'text',
          enum: [
            {
              label: 'GBP',
              value: '£',
            },
            {
              label: 'USD',
              value: '$',
            },

          ],
        },
        {
          name: 'price',
          type: 'string',
        },
        {
          name: 'text',
          type: 'richText',
        },
        {
          name: 'warningIcon',
          type: 'string',
          helperText: 'The name of any free FontAwesome icon. Find them at: https://fontawesome.com/search?o=r&m=free'
        },
        {
          name: 'warningText',
          type: 'longText',
          helperText: 'Optional, used to mention limited availability of Early Bird tickets, for example.'
        },
        {
          name: 'link',
          type: 'url',
        },
        {
          name: 'buttonText',
          type: 'string',
        },
      ],
    },
  ]
});

